import React from 'react';
import styled from 'styled-components';
import CoreImage from 'gatsby-theme-core/src/components/image';
import Column from '../../column';

const Image = ({
  // id,
  columnWidth,
  align,
  justify,
  order,
  image,
  maxWidth,
  className,
  offset,
}) => (!image ? null : (
  <Column
    className={className}
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    <div
      css={maxWidth ? `max-width: ${maxWidth}px` : ''}
    >
      <CoreImage
        image={image}
      />
    </div>
  </Column>
));

export default styled(Image)``;
